import { EllipsisHorizontalIcon, UserIcon } from "@heroicons/react/24/solid";
import { ICustomNode } from "modules/CarrierAgreementMgmt/Hierarchy/types";
import CSS from "csstype";

export default function HierarchyPdfOrgChartNode(props: { data: ICustomNode }) {
  const { data } = props;
  
  const parent_depth = data.depth;
  const { depth, row } = data;

  const colors_depth = [
    "#203A75",
    "#0C77BD",
    "#069EDB",
    "#58C9FE",
    "#9CE0FF",
    "#D2F1FF",
  ];

  const primary =
    (!row ? colors_depth[depth] : colors_depth[parent_depth + 1]) ??
    colors_depth[colors_depth.length - 1];

  //#region Styles for download
  const position: CSS.Properties = {
    width: "229px",
    height: data.data.hierarchyTypeName === "Frontline" ? "95px" : "115px",
    borderRadius: "8px",
    position: "relative",
    overflow: "visible",
    backgroundColor: "#ffffff",
    border:
      data.data.hierarchyTypeName === "Business Unit"
        ? "1px solid #203a75"
        : data.data.hierarchyTypeName === "Market"
        ? "1px solid #0c77bd"
        : data.data.hierarchyTypeName === "State"
        ? "1px solid #069edb"
        : data.data.hierarchyTypeName === "District"
        ? "1px solid #9ce0ff"
        : data.data.hierarchyTypeName === "Team"
        ? "1px solid #9ce0ff"
        : "1px solid #9ce0ff",
    boxSizing: "border-box",
  };

  const foldedCorner: CSS.Properties = {
    position: "absolute",
    top: "-2px",
    right: "12px",
    width: "0",
    height: "26px",
    borderTop: "19px solid transparent",
    marginTop: "-14px",
    transform: "rotate(140deg)",
    opacity: "80%",
    borderLeft: `21px solid ${primary}`,
    boxSizing: "border-box",
  };

  const ellipsis: CSS.Properties = {
    right: "9px",
    top: "2px",
    position: "absolute",
    cursor: "pointer",
  };

  const ellipsisIcon: CSS.Properties = {
    height: "1.5rem",
    width: "1.5rem",
    color: "#203A75",
  };

  const nameEllipsis: CSS.Properties = {
    backgroundColor: primary,
    width: "232px",
    height: "75px",
    color: "white",
    padding: "12px",
    borderTopLeftRadius: "20px",
    borderBottomLeftRadius: "20px",
    display: "flex",
    transform: "translateX(-12%)",
    clipPath: "polygon(0 0, 100% 0, 80% 100%, 0% 100%)",
    position: "relative",
    marginTop: "-20px",
    boxSizing: "border-box",
  };

  const userIconStyle: CSS.Properties = {
    borderRadius: "9999px",
    backgroundColor:
      data.data.hierarchyTypeName === "Frontline" ||
      data.data.hierarchyTypeName === "Team"
        ? "#203A75"
        : "white",
    width: "fit-content",
    height: "fit-content",
    padding: "0.75rem",
  };

  const nodeCardName: CSS.Properties = {
    color: "#ffffff",
  };

  const districtEmployeeName: CSS.Properties = {
    textDecoration: "underline",
    marginLeft: "0.5rem",
    marginBottom: "0.5rem",
    marginTop: "0px",
    color: "#203A75",
  };

  const textStyle: CSS.Properties = {
    fontSize: "0.75rem",
    color: "#203A75",
  };

  const employeeNumber: CSS.Properties = {
    marginLeft: "1rem",
    marginTop: "0.5rem",
    marginBottom: "0px",
    paddingLeft: "1rem",
    fontSize: "0.75rem",
    fontWeight: "normal",
    color: "#203A75",
  };

  const hierarchyName: CSS.Properties = {
    marginLeft: "1rem",
    marginTop: "0.25rem",
    marginBottom: "0px",
    paddingLeft: "1rem",
    fontSize: "0.75rem",
    fontWeight: "normal",
    color: "#203A75",
    textDecoration: "underline",
  };

  const employeeRoleTitle: CSS.Properties = {
    marginTop: "0px",
    marginBottom: "0px",
    marginRight: "0px",
    fontSize: "12px",
    marginLeft: "0.5rem",
  };

  const employeeName: CSS.Properties = {
    textDecoration: "underline",
    marginLeft: "0.5rem",
    marginBottom: "0.5rem",
    marginTop: "0px",
    fontSize: "12px",
  };
  //#endregion

  return (
    <div style={position}>
      {data.data.hierarchyTypeName === "District" ? (
        <>
          <div style={foldedCorner}></div>
          <div style={ellipsis}>
            <EllipsisHorizontalIcon style={ellipsisIcon} />
          </div>
          <div style={nameEllipsis}>
            <div style={userIconStyle}>
              <UserIcon
                className={"w-4"}
                style={{ fill: primary, width: "1rem" }}
              />
            </div>
            <div style={nodeCardName}>
              <h3 style={districtEmployeeName}>{data.data.employeeName}</h3>

              <div style={textStyle}>
                <h3 style={employeeRoleTitle}>{data.data.employeeRole}</h3>
              </div>
              <div style={textStyle}>
                <h3 style={employeeRoleTitle}>{data.data.hierarchyTypeName}</h3>
              </div>
            </div>
          </div>
        </>
      ) : (
        <>
          <div style={foldedCorner}></div>
          <div style={ellipsis}>
            {data.data.parentId !== "" &&
              data.data.hierarchyTypeName !== "Frontline" && (
                <EllipsisHorizontalIcon
                  className={`h-6 w-6 text-primary`}
                  style={ellipsisIcon}
                />
              )}
          </div>
          <div style={nameEllipsis}>
            <div style={userIconStyle}>
              <UserIcon
                style={{
                  fill:
                    data.data.hierarchyTypeName === "Frontline" ||
                    data.data.hierarchyTypeName === "Team"
                      ? "white"
                      : primary,
                  width: "1rem",
                }}
              />
            </div>
            <div
              style={
                data.data.hierarchyTypeName === "Frontline" ||
                data.data.hierarchyTypeName === "Team"
                  ? { color: "#203A75" }
                  : nodeCardName
              }
            >
              <h3 style={employeeName}>{data.data.employeeName}</h3>

              <div style={{ fontSize: "0.75rem" }}>
                <h3 style={employeeRoleTitle}>
                  {data.data.hierarchyTypeName === "Frontline" ||
                  data.data.employeeName === "Tom Hammond"
                    ? data.data.employeeTitle
                    : data.data.employeeRole}
                </h3>
              </div>
              <div style={{ fontSize: "0.75rem" }}>
                <h3 style={employeeRoleTitle}>
                  {(data.data.hierarchyTypeName !== "Frontline" &&
                    data.data.parentId !== "") ||
                  data.data.parentId === ""
                    ? data.data.hierarchyTypeName
                    : data.data.hierarchyTypeName === "Frontline" &&
                      data.data.parentId !== ""
                    ? data.data.hierarchyName
                    : ""}
                </h3>
              </div>
            </div>
          </div>
        </>
      )}
      <div>
        <h3 style={employeeNumber}>{data.data.employeeNumber}</h3>
      </div>
      <div>
        <h3 style={hierarchyName}>
          {(data.data.hierarchyTypeName !== "Frontline" &&
            data.data.parentId !== "") ||
          data.data.parentId === ""
            ? data.data.hierarchyName
            : ""}
        </h3>
      </div>
    </div>
  );
}
